import { render, staticRenderFns } from "./security_messages.vue?vue&type=template&id=703e7ee9&scoped=true"
import script from "./security_messages.vue?vue&type=script&lang=js"
export * from "./security_messages.vue?vue&type=script&lang=js"
import style0 from "./security_messages.vue?vue&type=style&index=0&id=703e7ee9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703e7ee9",
  null
  
)

export default component.exports